import AFRAME from "aframe";
import htmlRenderer from "./html-renderer";

AFRAME.registerComponent('html-dev', {
    dependencies: [],
    schema: {
        ppu: {type: 'number', default: 1000},
        autoEnable: {type:'boolean',default: false}
    },
    target: null,
    canvas: null,
    material: null,
    observer: null,
    enabled: false,
    init: function () {
        const me = this;
        me.target = this.el.firstElementChild;
        
        me.el.setAttribute('material', {
            visible: false,
        });
        
        if (me.data.autoEnable) {
            me.enable();
        }
    },
    enable: function() {
        const me = this;
        if (me.enabled === false) {
            me.enabled = true;
            me.setupCanvasMaterial();
            me.setupHtmlWatcher();
            me.render();
        }
    },
    pixelsToMeters: function(pixels) {
        return Math.round(pixels / this.data.ppu * 1000) / 1000;
    },
    metersToPixels: function(meters) {
        return Math.round(meters * this.data.ppu * 1000) / 1000;
    },
    setupHtmlWatcher: function() {
        const me = this;
        me.observer = new MutationObserver(() => {
            me.render()
        });

        this.observer.observe(this.target, {
            childList: true,
            attributes: true,
            attributeFilter: ['src'],
            characterData: true,
            subtree: true,
        });
    },
    setupCanvasMaterial: function() {
        const me = this;

        me.canvas = document.createElement("canvas");

        me.texture = new THREE.CanvasTexture(me.canvas);
        me.texture.minFilter = THREE.LinearFilter;
        me.texture.wrapS = THREE.ClampToEdgeWrapping;
        me.texture.wrapT = THREE.ClampToEdgeWrapping;

        me.material = new THREE.MeshBasicMaterial({
            map: me.texture,
            transparent: true
        });

        me.geometry = new THREE.PlaneGeometry(0, 0);

        me.screen = new THREE.Mesh(me.geometry, me.material);
        me.el.setObject3D('screen', me.screen);
    },
    render: function() {
        this.renderHtml();
    },
    renderHtml: function() {
        const me = this;
        const html = me.target.outerHTML;
        htmlRenderer.render(html).then(canvas => {

            const ctx = me.canvas.getContext("2d");
            me.canvas.width = canvas.width;
            me.canvas.height = canvas.height;
            ctx.drawImage(canvas, 0, 0);
            
            const width = me.pixelsToMeters(canvas.width);
            const height = me.pixelsToMeters(canvas.height);
            
            me.screen.geometry = me.geometry = new THREE.PlaneGeometry(width, height);
            me.texture.needsUpdate = true;
            me.material.needsUpdate = true;
            me.material.map.needsUpdate = true;
            
            me.el.setAttribute('geometry', {
                width: width,
                height: height,
            });

            me.el.emit('rendered');
            
            let el = me.el.closest('a-yoga-layout');
            if (el) {
                el.components['yoga-layout'].renderLayout();
            }
        })
    }
});

AFRAME.registerPrimitive('a-html', {
    defaultComponents: {
        'html-dev': {}
    },
    mappings: {
        'ppu': 'html-dev.ppu',
        'auto-enable': 'html-dev.autoEnable',
    },
});